<template>
  <div class="form-group">
    <h3>Step {{ currentStep }}. Your collaborators</h3>
    <div class="infomsg">Please add the names and emails of any people, parents, or guardians you would like to involve in the booking of your flights. They will also receive booking notifications.</div>

    <div v-for="(collab, index) in modelValue" :key="index" class="form-row">
      <div class="form-col">
        <input :value="collab.name" type="text" :placeholder="index || config.options?.is_collaborators_optional ? 'Full name (optional)' : 'Full name'" @input="updateCollaborator(index, 'name', $event.target.value)" />
      </div>
      <div class="form-col">
        <input :value="collab.email" type="text" :placeholder="index || config.options?.is_collaborators_optional ? 'Email address (optional)' : 'Email address'" @input="updateCollaborator(index, 'email', $event.target.value)" />
      </div>
      <div class="form-col">
        <input :value="collab.relationship" type="text" :placeholder="index || config.options?.is_collaborators_optional ? 'Relationship (optional)' : 'Relationship'" @input="updateCollaborator(index, 'relationship', $event.target.value)" />
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  config: {
    type: Object,
    required: true,
  },
  currentStep: {
    type: Number,
    required: true,
  },
  modelValue: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(["update:modelValue"]);

// Handle collaborator updates
const updateCollaborator = (index, field, value) => {
  const updatedCollaborators = [...props.modelValue];
  updatedCollaborators[index] = {
    ...updatedCollaborators[index],
    [field]: value,
  };
  emit("update:modelValue", updatedCollaborators);
};
</script>
